{
  "title": "Ҳамён",
  "subtitle": "Баланс танҳо аз сервер хонда мешавад. Амалиётҳои ҳақиқӣ фаъол нестанд.",
  "real": "Баланси асосӣ",
  "bonus": "Бонус",
  "reserved": "Резерв",
  "unavailable": "Маълумоти баланс дастнорас аст",
  "deposit": "Амонат",
  "withdraw": "Бардошт",
  "history": "Таърих",
  "comingSoon": "Ҷараёнҳои пардохт ба наздикӣ"
}
